import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';

function App() {
    const [url, setUrl] = useState('');

    const checkLink = (arrayUrl, unUrl) => {
        let check = false;

        arrayUrl.map(x => {
            if (window.location.href.includes(x)) {
                check = true;
            }
        });

        if (check && unUrl) {
            unUrl.map(x => {
                if (window.location.href.includes(x)) {
                    check = false;
                }
            });
        }
        return check ? 'active' : '';
    };

    const reRender = () => {
        if (window.location.href !== url) {
            setUrl(window.location.href);
        } else {
            setUrl('');
        }
    };

    const clickLogout = e => {
        localStorage.setItem('login_pwd', '');
        localStorage.setItem('id', '');
        localStorage.setItem('role', '');
        localStorage.setItem('name', '');
        localStorage.setItem('email', '');

        localStorage.setItem('access_token', '');
        localStorage.setItem('refresh_token', '');
        localStorage.setItem('token_type', '');
        localStorage.setItem('expires_in', '');

        window.location.href = '/';
    };

    let name = localStorage.getItem('name', '');
    const role = localStorage.getItem('role', '');
    name += role === 'ADMIN' ? ' (관리자)' : ' (지사)';

    return (
        <div>
            <div>
                <header className="hd">
                    <div className="top_row">
                        <h1 className="logo">
                            <a href="javascript:;">
                                <b>한국분동(주)</b> / 배차일정관리시스템
                            </a>
                        </h1>

                        <ul className="r_top_menu">
                            <li>
                                <a>KW24</a>
                            </li>
                            <li>
                                <a>{name} 님</a>
                            </li>

                            {role === 'ADMIN' && (
                                <li>
                                    <Link to="/a/admin/list" onClick={reRender}>
                                        정보수정
                                    </Link>
                                </li>
                            )}
                            <li>
                                <a href="javascript:;" className="log" onClick={clickLogout}>
                                    로그아웃
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="gnb_box">
                        <div className="group">
                            <Link to="/a/home/info" className="main" onClick={reRender}>
                                MAIN
                            </Link>
                            <Link to="/a/batcha/list" className={checkLink(['batcha'], ['completelist'])} onClick={reRender}>
                                배차관리 / 본사배차
                            </Link>
                            <Link to="/a/batcha/completelist" className={checkLink(['batcha/completelist'])} onClick={reRender}>
                                운송완료현황
                            </Link>
                            <Link to="/a/stats/jobs" className={checkLink(['stats'])} onClick={reRender}>
                                운반통계
                            </Link>
                        </div>

                        <div className="group">
                            {role === 'ADMIN' && (
                                <Link to="/a/manager/list" className={checkLink(['manager'], ['placemanager'])} onClick={reRender}>
                                    검사원관리
                                </Link>
                            )}
                            {role === 'ADMIN' && (
                                <Link to="/a/placemanager/list" className={checkLink(['placemanager'])} onClick={reRender}>
                                    현장담당관리
                                </Link>
                            )}
                            {role === 'ADMIN' && (
                                <Link to="/a/branch/list" className={checkLink(['branch'])} onClick={reRender}>
                                    지사관리
                                </Link>
                            )}
                            <Link to="/a/driver/list" className={checkLink(['driver'])} onClick={reRender}>
                                기사관리
                            </Link>
                            <Link to="/a/report/list" className={checkLink(['report'])} onClick={reRender}>
                                교육일지
                            </Link>
                        </div>

                        {role === 'ADMIN' && (
                            <div className="group">
                                <Link to="/a/notice/list" className={checkLink(['notice'])} onClick={reRender}>
                                    공지사항
                                </Link>
                                <Link to="/a/board/list" className={checkLink(['board'])} onClick={reRender}>
                                    자료실
                                </Link>
                                <Link to="/a/basic/edit" className={checkLink(['basic'])} onClick={reRender}>
                                    기본항목
                                </Link>
                            </div>
                        )}

                        {role === 'ADMIN' && (
                            <div className="group">
                                <a href="https://hosting.cafe24.com" target="_blank">
                                    SMS문자관리
                                </a>
                                <a href="https://console.cafe24.com/main" target="_blank">
                                    KW24서버관리
                                </a>
                            </div>
                        )}

                        {role !== 'ADMIN' && <div className="group"></div>}
                        {role !== 'ADMIN' && <div className="group"></div>}
                        {role !== 'ADMIN' && <div className="group"></div>}
                        {role !== 'ADMIN' && <div className="group"></div>}
                        {role !== 'ADMIN' && <div className="group"></div>}
                        {role !== 'ADMIN' && <div className="group"></div>}
                    </div>
                </header>
            </div>
            <div className="hankook_con">
                <Outlet />
            </div>
            <div>
                <button
                    className="top_up_btn"
                    onClick={e => {
                        window.scrollTo(0, 0);
                    }}
                >
                    <i className="xi-angle-up"></i>
                </button>
            </div>
        </div>
    );
}

export default App;
